import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from './store/store.js';
import { Provider } from 'react-redux';
import "@radix-ui/themes/styles.css";
import { Theme } from '@radix-ui/themes';


const root = createRoot(document.getElementById('root'))
root.render(
  <Theme accentColor="cyan" grayColor="slate" appearance="dark">
  <Provider store={store}>
    <App />
  </Provider>
</Theme>
)